import { IBblDataItem } from "../../contracts/_deprecated/Bbl";
import { IZeosApiResponse } from "../../contracts/ZeosApi";
import { getDataAsync } from "../../ZeosApiExecutor";
import { IBblData } from "../interfaces/_deprecated/IBBLData";

export const BblData: IBblData = {
  getMonthlyData: async (): Promise<IZeosApiResponse<IBblDataItem[]>> => {
    return await getDataAsync<IBblDataItem[]>("bblData/monthlydata", "data");
  },
};
